import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.5.19_@opentelemetry+api@1.9.1_@playwright+test@1.60.0_react-dom@19.2.7_react@19.2.7__react@19.2.7/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["SetLogo"] */ "/app/src/components/set-logo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Price"] */ "/app/src/lib/currency.tsx");
